export default __webpack_public_path__ + "../staticImages/confirmation-header-d.webp";